import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pt-autocomplete-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "autocomplete-tabs" }
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = { class: "autocomplete-tab-label" }
const _hoisted_6 = { class: "autocomplete-option-content" }
const _hoisted_7 = {
  key: 0,
  class: "autocomplete-option-title"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "text-body--sm pt-autocomplete__error",
  "data-testid": "pt-autocomplete-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.inputId,
          class: "text-heading--sm pt-form-label",
          "data-testid": "pt-autocomplete-label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_AutoComplete, {
      ref: "autoInput",
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      suggestions: _ctx.tabFilteredSuggestions,
      name: _ctx.name,
      "input-id": _ctx.inputId,
      placeholder: _ctx.placeholder,
      invalid: _ctx.invalid,
      "auto-option-focus": true,
      disabled: _ctx.readOnly,
      "show-empty-message": false,
      "force-selection": _ctx.selectOnly,
      "option-label": _ctx.isObjectMode ? _ctx.optionLabel : undefined,
      "option-disabled": _ctx.isObjectMode ? _ctx.optionDisabled : undefined,
      "complete-on-focus": _ctx.showOptionsOnFocus,
      onComplete: _ctx.onComplete,
      onClear: _ctx.onClear,
      onOptionSelect: _ctx.handleOptionSelect,
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
      onChange: _ctx.onChange
    }, _createSlots({ _: 2 }, [
      (_ctx.tabMode && _ctx.tabs && _ctx.tabs.length > 0)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    type: "button",
                    class: _normalizeClass([
              'autocomplete-tab',
              { 'autocomplete-tab-active': _ctx.selectedTabIndex === index },
            ]),
                    disabled: tab.getCount(_ctx.allSuggestions) === 0,
                    onClick: ($event: any) => (_ctx.selectTab(index))
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(tab.label), 1),
                    (_ctx.showTabBadges)
                      ? (_openBlock(), _createBlock(_component_Badge, {
                          key: 0,
                          value: tab.getCount(_ctx.allSuggestions).toString(),
                          severity: _ctx.selectedTabIndex === index ? undefined : 'secondary',
                          size: "small"
                        }, null, 8, ["value", "severity"]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_4))
                }), 128))
              ])
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.$slots.option)
        ? {
            name: "option",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "option", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "1"
          }
        : {
            name: "option",
            fn: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.getSuggestionTitle(slotProps.option))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.getSuggestionTitle(slotProps.option)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "autocomplete-option-name",
                  innerHTML: _ctx.highlightQueryMatch(slotProps.option)
                }, null, 8, _hoisted_8)
              ])
            ]),
            key: "2"
          }
    ]), 1032, ["modelValue", "suggestions", "name", "input-id", "placeholder", "invalid", "disabled", "force-selection", "option-label", "option-disabled", "complete-on-focus", "onComplete", "onClear", "onOptionSelect", "onChange"]),
    (_ctx.invalid && _ctx.errorText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.errorText), 1))
      : _createCommentVNode("", true)
  ]))
}